// @flow
import type { Product } from 'digicel-kaizen-library';
import type { FetchPromoProductsRequestActionType, SetPromoProductsActionType } from './types';

type Action = FetchPromoProductsRequestActionType | SetPromoProductsActionType;

export type PromoProductsStateType = Product[];

const initialState: PromoProductsStateType = [];

export default (state: PromoProductsStateType = initialState, action: Action) => {
  switch (action.type) {
    case 'SET_PROMO_PRODUCTS':
      return action.payload.promoProducts;
    default:
      return state;
  }
};
